import { localStorageInstance } from '@gem/modules/storage';
import { parseJSON } from '@gem/utils';

import { DEFAULT_CHAT_BACKGROUND } from 'APP/store/Appearance/Appearance.contants';
import { TChatBackground } from 'APP/store/Appearance/Appearance.types';

const KEY_NAME = 'chatBackgroundGlobal';

const getKeyWithUserId = (userId: string | null): string => {
  return userId ? `${KEY_NAME}_${userId}` : KEY_NAME;
};

export const set = (chatBackground: TChatBackground, userId: string | null = null): void => {
  localStorageInstance.setItem(getKeyWithUserId(userId), JSON.stringify(chatBackground));
};

export const get = (userId: string | null = null): TChatBackground => {
  const value: string | null = localStorageInstance.getItem(getKeyWithUserId(userId));

  if (!value) {
    return DEFAULT_CHAT_BACKGROUND;
  }

  const chatBackground = parseJSON(value);

  if (!chatBackground) {
    return DEFAULT_CHAT_BACKGROUND;
  }

  return chatBackground ?? DEFAULT_CHAT_BACKGROUND;
};

export const remove = (userId: string | null = null): void => {
  localStorageInstance.removeItem(getKeyWithUserId(userId));
};
